import {VisualBox} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/VisualBox';
import {Page} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {Repeater} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/Repeater';
import {BoxView} from '@mintdata-wsp/pub/view/BoxView';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {css} from 'glamor';

const styles = require('./SurfacePage.less');
const cx = classnames.bind(styles);

export interface ISurfacePageProps
{
    page:Page;
    isActive:boolean;
    isOverlay:boolean;
    allowAnimation:boolean;
    isHidden?:boolean;
    stackIndex?:number;
}

interface ISurfacePageState
{
    animationClassNames:string[];
}

@observer
export class SurfacePage extends React.Component<ISurfacePageProps, ISurfacePageState>
{
    public static defaultProps:Partial<ISurfacePageProps> = {
        stackIndex: -1,
        isHidden: false,
    };

    state:ISurfacePageState = {
        animationClassNames: []
    };

    componentDidUpdate(prevProps:ISurfacePageProps)
    {
        let classNames:string[] = [];


        if (this.props.allowAnimation)
        {
            if( prevProps.isActive && !this.props.isActive ) {
                classNames.push('disappearingPage');
                classNames.push('wasChangedActivePage');
            }

            if ( !prevProps.isActive && this.props.isActive )
            {
                classNames.push('appearingPage');
                classNames.push('wasChangedActivePage');
            }

            if ( !prevProps.isOverlay && this.props.isOverlay )
                classNames.push('appearingOverlay');

            if( prevProps.isOverlay && !this.props.isOverlay )
                classNames.push('disappearingOverlay');

            if (classNames.length > 0)
                this.setState({animationClassNames: classNames});
        }
        else if (this.state.animationClassNames.length > 0){
            this.setState({animationClassNames: []});
        }
    }

    public render():JSX.Element
    {
        const {page, stackIndex, isActive, isOverlay, isHidden} = this.props;
        const {animationClassNames} = this.state;

        const boxesElements:Array<JSX.Element> = page.artboard.visualBoxes.reduce((boxesElements, childVisualBox:VisualBox) =>
        {
            const isViewport:boolean = childVisualBox.box.isViewport;

            return isViewport && boxesElements.concat(childVisualBox.repeaters.map((repeater:Repeater) => (
                <BoxView
                    key={`${childVisualBox.box.id}_${repeater.index}`}
                    visualBox={childVisualBox}
                    repeater={repeater}
                    isInOverlays={isOverlay}
                    isHiddenOverlay={isHidden}
                />
            )));
        }, []);

        const style = {
            zIndex: isActive
                ? 1
                : isOverlay
                    ? 2 + stackIndex
                    : 0
        };

        const childrenStyle = css({
            [`&:not(.${styles.isActive}):not(.${styles.isShowedOverlay}) [data-box-view="true"]`]: {
                pointerEvents: 'none !important'
            }
        });

        const animationClassNamesObj:any = animationClassNames.reduce((res:any, className:string) => {
            res[className] = true;
            return res;
        }, {});

        return (
            <div
                className={cx('page', {
                    isOverlay,
                    isActive,
                    isShowedOverlay: isOverlay && !isHidden,
                    ...animationClassNamesObj,
                })}
                style={style}
                {...childrenStyle}
            >
                {boxesElements}
            </div>
        );
    }
}
